module.exports = __webpack_public_path__ + "98785b43d7a60290e358a0a92bb028c5.svg";